import {h, Fragment} from "preact"
const comingSoonTagTemplate = window.theme?.productTags?.coming_soon;
const soldOutTagTemplate = window.theme?.productTags?.sold_out;

export const BabyAgeGroupTag = () => {
    return (
        <a href="/collections/mini-baby" class="tag tag--uppercase tag--baby">
            <span className="visually-hidden">Shop Baby collection</span>
            <span aria-hidden="true">Baby</span>
        </a>
    )
}

export const KidsAgeGroupTag = () => {
    return (
        <a href="/collections/mini-kids" class="tag tag--uppercase tag--kids">
            <span className="visually-hidden">Shop Kids collection</span>
            <span aria-hidden="true">Kids</span>
        </a>
    )
}

export const ComingSoonTag = () => {
    return (
        <div dangerouslySetInnerHTML={{ __html: comingSoonTagTemplate }} />
    )
}

export const SoldOutTag = () => {
    return (
        <div dangerouslySetInnerHTML={{ __html: soldOutTagTemplate }} />
    )
}